import { render, staticRenderFns } from "./qa.vue?vue&type=template&id=6263d51c"
import script from "./qa.vue?vue&type=script&lang=js"
export * from "./qa.vue?vue&type=script&lang=js"
import style0 from "./qa.vue?vue&type=style&index=0&id=6263d51c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports